import axios from 'axios';
import {ApiResponse, FileType} from '../types';

type GetFileTypeResponse = ApiResponse<{fileTypes: FileType[]}>;
const GET_FILE_TYPES = '/generalData/getFileTypeIDs';

export const getFileTypes = async () => {
  const response = await axios.get<GetFileTypeResponse>(GET_FILE_TYPES, {});
  const {body, errorCode} = response.data;

  if (errorCode < 0) throw new Error();

  return body.fileTypes;
};
